// Mine
// export default {
//   cognito: {
//     UserPoolId: 'eu-central-1_WpK26oGwn', // Your user pool id here
//     ClientId: '41nmn4bmaurdlg2du0usou7blp' // Your client id here
//   }
// }

// Sandbox
export default {
  cognito: {
    UserPoolId: 'eu-central-1_vtVFeVuX4', // Your user pool id here
    ClientId: '36l39fffcsqifaf4kjreb06db4' // Your client id here
  }
}

// export default {
//   cognito: {
//     UserPoolId: 'eu-central-1_jLaio74XF', // Your user pool id here
//     ClientId: '6m2kdvcg9bk5l9p5fut1vqel62' // Your client id here
//   }
// }



// WEBPACK FOOTER //
// ./src/userpoolconfig.js